<template>
  <div>
    <v-layout column class="mt-0">
      <v-flex xs12 mt-1 mx-2>
        <!-- ADD CONSERVATION -->
        <v-btn
          class="mt-0 mb-0 ml-0 xs12"
          v-if="!showUpload && c_user.edit"
          @click="showUpload = !showUpload"
          small
          >Add Conservation</v-btn
        >
        <!-- <span  class="right" v-if="artwork.conservations && artwork.conservations.length > 0">
            Conservation History
            <v-btn icon small @click="showList=!showList">
              <v-icon v-if="!showList">expand_more</v-icon>
              <v-icon v-if="showList">expand_less</v-icon>
            </v-btn>
          </span> -->

        <!-- <v-btn
            class="mt-0 mb-1 ml-0 xs12"
            v-if="showUpload"
            @click="showUpload=!showUpload"
            small
          >
            <v-icon left>close</v-icon>Cancel
        </v-btn>-->
        <v-card
          v-if="showUpload || edit"
          class="mx-0 px-0 pt-0 mb-2 elevation-2"
        >
          <v-card-text class="px-4">
            <v-flex class="xs12">
              <v-text-field
                prepend-inner-icon="person"
                v-model="conservation.conservator"
                name="conservator"
                label="Conservator"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-menu
                v-model="menu2"
                :return-value.sync="conservation.last_condition_check"
                ref="menu2"
                :close-on-content-click="true"
                :nudge-right="30"
                :nudge-top="20"
                lazy
                landscape
                offset-y
                full-width
                min-width="290px"
              >
                <!-- transition="scale-transition" -->
                <v-text-field
                  v-model="conservation.last_condition_check"
                  slot="activator"
                  label="Last Condition Check"
                  prepend-inner-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  persistent
                  color="black"
                  v-model="conservation.last_condition_check"
                  @input="$refs.menu2.save(conservation.last_condition_check)"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="xs12">
              <v-text-field
                v-model="conservation.reason"
                name="reason"
                label="Reason for Condition Report"
              ></v-text-field>
            </v-flex>

            <v-flex class="xs12">
              <v-text-field
                v-model="conservation.basic_condition_notes"
                name="basic_condition_notes"
                label="Basic Conservation Description"
              ></v-text-field>
            </v-flex>

            <v-flex class="xs12">
              <v-text-field
                prepend-inner-icon="link"
                v-model="conservation.link"
                name="link"
                label="Link"
              ></v-text-field>
            </v-flex>
          </v-card-text>

          <v-card-actions class="px-4">
            <v-flex class="xs12"></v-flex>
            <v-flex class="xs12 mb-3">
              <v-btn
                v-if="!edit"
                small
                class="right"
                dark
                :disabled="saving"
                @click="save_conservation"
                >save</v-btn
              >
              <v-btn
                v-else
                small
                class="right"
                dark
                :disabled="saving"
                @click="update_conservation"
                >save</v-btn
              >
              <v-btn small @click="cancelAddEdit">cancel</v-btn>
            </v-flex>
          </v-card-actions>
          <v-progress-linear
            width="2"
            indeterminate
            v-if="saving"
          ></v-progress-linear>
        </v-card>

        <!-- LIST CONSERVATIONS -->
        <v-flex
          class="xs12 my-3 pt-0"
          v-if="artwork.conservations && artwork.conservations.length > 0"
        >
          <!-- v-if="showList" -->
          <!-- <v-flex class="py-0 my-0"> -->
          <!-- <v-slide-y-transition group tag="v-list" class="py-0 my-0"> -->
          <v-card
            v-for="l in artwork_conservations"
            class="pa-3 my-0 elevation-1"
            :key="l.id"
          >
            <!-- <v-list-tile :key="l.id" class="py-0 my-0" ripple> -->
            <!-- <v-list-tile-content class="my-0 py-0"> -->
            <!-- <v-list-tile-title class="py-0 my-0"> -->
            <span
              >LAST CONDITION CHECK:
              <b>{{
                l.last_condition_check ? l.last_condition_check : 'NOT ENTERED'
              }}</b></span
            >
            <!-- </v-list-tile-title> -->

            <v-flex class="py-1 my-0">
              REASON: <b>{{ l.reason ? l.reason : 'NOT ENTERED' }}</b>
            </v-flex>

            <v-flex class="py-1 my-0">
              CONSERVATOR:
              <b>{{ l.conservator ? l.conservator : 'NOT ENTERED' }}</b>
            </v-flex>

            <v-flex class="py-1 my-0">
              BASIC CONSERVATION DESCRIPTION:
              <b>{{
                l.basic_condition_notes
                  ? l.basic_condition_notes
                  : 'NOT ENTERED'
              }}</b>
            </v-flex>

            <v-flex v-if="l.link" class="py-0 my-0">
              <a :href="l.link">
                <v-icon small>link</v-icon>
                Conservation Folder</a
              >
            </v-flex>

            <!-- <v-list-tile-sub-title v-if="l.conservator" class="py-0 my-0">
                      <div v-if="l.basic_condition_notes"> {{l.basic_condition_notes}}</div>
                    </v-list-tile-sub-title> -->
            <!-- </v-list-tile-content> -->
            <!-- (Added {{l.change_date}} by {{l.created_by}}) -->
            <!-- <v-list-tile-action> -->
            <v-flex d-flex>
              <v-flex v-if="l.created_by"
                >{{ get_abb(l.created_by) }} {{ format_date(l.created_at) }}
              </v-flex>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                @click="delete_log(l)"
                icon
                small
                red
                v-if="c_user.delete_rights"
                ><v-icon small color="red">delete</v-icon></v-btn
              >
              <v-btn @click="edit_log(l)" icon small v-if="c_user.edit"
                ><v-icon small red>edit</v-icon></v-btn
              >
            </v-flex>

            <!-- </v-list-tile-action> -->
            <!-- </v-list-tile> -->
            <!-- <v-divider :key="`divider_${l.id}`" class="my-0 py-0"></v-divider> -->
          </v-card>
          <!-- </v-slide-y-transition> -->
        </v-flex>
        <!-- </v-list> -->
      </v-flex>

      <!-- <v-flex xs12 mt-1 mx-2 v-if="c_user.edit">
        <v-btn
          class="mt-0 mb-0 ml-0 xs12"
          v-if="!showOld"
          @click="showOld=!showOld"
          small
        >Conservation History</v-btn>

        <v-card v-if="showOld" class="mx-0 px-0 pt-0 mb-2 elevation-2">
          <v-card-text class="px-4">

            <v-flex class="xs12">
              <v-text-field
                prepend-inner-icon="person"
                v-model="artwork.conservator"
                name="conservator"
                label="Conservator"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-menu
                v-model="menu2"
                :return-value.sync="artwork.last_media_check"
                ref="menu2"
                :close-on-content-click="true"
                :nudge-right="30"
                :nudge-top="20"
                lazy
                landscape
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  v-model="artwork.last_media_check"
                  slot="activator"
                  label="Last Condition Check"
                  prepend-inner-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  persistent
                  v-model="artwork.last_media_check"
                  @input="$refs.menu2.save(artwork.last_media_check)"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="xs12">
              <v-text-field
                v-model="artwork.reason_for_update"
                name="reason_for_update"
                label="Basic Conservation Description"
              ></v-text-field>
            </v-flex>

          </v-card-text>

          <v-card-actions class="px-4">
            <v-flex class="xs12"></v-flex>
            <v-flex class="xs12 mb-3">
              <v-btn small class="right" @click="showOld=!showOld">close</v-btn>
            </v-flex>
          </v-card-actions>
          <v-progress-linear width="2" indeterminate v-if="saving"></v-progress-linear>
        </v-card>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { serverBus } from '../../main'

export default {
  props: ['artwork'],
  data: () => ({
    menu2: false,
    showUpload: false,
    edit: false,
    showOld: false,
    saving: false,
    showList: false,
    show: false,
    errors: '',
    conservation: {
      reason: '',
      created_by: '',
      link: '',
      basic_condition_notes: '',
      conservator: '',
      last_condition_check: '',
    },
  }),
  // beforeCreate() {
  //   setTimeout(
  //     function() {
  //       // this.$store.dispatch("saveCurrentTab", tab)
  //     }.bind(this),
  //     3000
  //   );
  // },
  computed: {
    artwork_conservations() {
      var out = this.artwork.conservations.sort(function (a, b) {
        if (b.last_condition_check > a.last_condition_check) {
          return 1
        } else {
          return -1
        }
      })
      return out
    },
  },
  methods: {
    cancelAddEdit() {
      this.showUpload = false
      this.edit = false
      this.conservation = {
        reason: '',
        conservator: '',
        created_by: '',
        link: '',
        basic_condition_notes: '',
        last_condition_check: '',
      }
    },
    // location_name(id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id);
    //     if (a) {
    //       return a.name;
    //     } else {
    //       return "Location not found in CMS.";
    //     }
    //   } else {
    //     return "Location not found in CMS.";
    //   }
    // },
    download() {},
    delete_log(l) {
      let url = `${this.$globals.apiserver}/conservations/${l.id}.json`
      axios
        .delete(url, l)
        .then((response) => {
          this.$emit('getArtwork')
          serverBus.$emit(
            'showSnackbar',
            'Conservation deleted.',
            'rgba(0, 125, 0, 0.8)'
          )
        })
        .catch((error) => {
          serverBus.$emit(
            'showSnackbar',
            'Error occuredd while deleting Conservation.',
            'rgba(125, 0, 0, 0.8)'
          )
          // console.log(error)
        })
    },
    edit_log(c) {
      console.log(c)
      this.conservation = c
      this.edit = true
      // serverBus.$emit('showSnackbar', 'not implemented yet', "rgba(125, 0, 0, 0.8)")
    },
    update_conservation() {
      serverBus.$emit('showSnackbar', 'Saving ...', 'rgba(0, 0, 0, 0.9)')
      this.saving = true
      // this.conservation.artwork_id = this.artwork.id;
      // console.log(this.c_user.id);
      // this.conservation.created_by = this.c_user.id;
      // if (!this.artwork.conservations) {
      //   this.artwork.conservations = [];
      // }
      // this.$store.commit('ADD_TODO', this.conservation)
      // this.all_conservations.push(this.conservation)
      axios
        .put(
          `${this.$globals.apiserver}/conservations/${this.conservation.id}.json`,
          {
            conservation: this.conservation,
          }
        )
        .then((response) => {
          this.$emit('getArtwork')
          serverBus.$emit('showSnackbar', 'Saved.', 'rgba(0, 125, 0, 0.9)')
          this.errors = {}
          // this.artwork.conservations.push(response.data);
          // console.log(this.conservation.artwork_location_id)
          // this.$store.commit("ADD_CONSERVATION", response.data);
          // this.active_conservations = this.$store.state.conservations;
          this.showUpload = false
          this.edit = false
          // this.artwork.last_media_check = this.conservation.last_condition_check
          this.conservation = {
            reason: '',
            conservator: '',
            created_by: '',
            link: '',
            basic_condition_notes: '',
            last_condition_check: '',
          }
          this.saving = false
        })
        .catch((error) => {
          serverBus.$emit(
            'showSnackbar',
            'Problem while saving.',
            'rgba(125, 0, 0, 0.8)'
          )
          console.log(error)
          this.saving = false
          // this.errors = error.response.data;
        })
      // var aconservation = Object.keys(this.conservation).forEach(k => this.conservation[k]='')
      // console.log(aconservation)
    },
    save_conservation() {
      serverBus.$emit('showSnackbar', 'Saving ...', 'rgba(0, 0, 0, 0.8)')
      this.saving = true
      this.conservation.artwork_id = this.artwork.id
      // console.log(this.c_user.id);
      this.conservation.created_by = this.c_user.id
      if (!this.artwork.conservations) {
        this.artwork.conservations = []
      }
      // this.$store.commit('ADD_TODO', this.conservation)
      // this.all_conservations.push(this.conservation)
      axios
        .post(`${this.$globals.apiserver}/conservations.json`, {
          conservation: this.conservation,
        })
        .then((response) => {
          serverBus.$emit('showSnackbar', 'Saved.', 'rgba(0, 125, 0, 0.8)')
          this.errors = {}
          this.artwork.conservations.push(response.data)
          // console.log(this.conservation.artwork_location_id)
          this.$store.commit('ADD_CONSERVATION', response.data)
          // this.active_conservations = this.$store.state.conservations;
          this.showUpload = !this.showUpload
          this.artwork.last_media_check = this.conservation.last_condition_check
          this.conservation = {
            reason: '',
            conservator: '',
            created_by: '',
            link: '',
            basic_condition_notes: '',
            last_condition_check: '',
          }
          this.$emit('getArtwork')
          this.saving = false
        })
        .catch((error) => {
          serverBus.$emit(
            'showSnackbar',
            'Problem while saving.',
            'rgba(125, 0, 0, 0.8)'
          )
          console.log(error)
          this.saving = false
          // this.errors = error.response.data;
        })
      // var aconservation = Object.keys(this.conservation).forEach(k => this.conservation[k]='')
      // console.log(aconservation)
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/artworks/Conservation.vue